/**
 *
 * StudentHeaders
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { last } from 'lodash-es';
import Icon from 'components/media/Icon/index.js';
import { shortTimeString } from 'utils/eventTimes.js';
import messages from './messages.js';

const NamesWrapper = styled.div`
  display: flex;
  margin-left: 47px;
  align-items: stretch;
`;

const EventName = styled.div`
  font-size: 14px;
  font-weight: normal;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  justify-content: space-between;
  flex: ${(p) => p.numCols};
`;

const SlotAlert = styled.div`
  display: inline-block;
  padding: 0 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  font-size: 12px;
  height: 20px;
  white-space: nowrap;
  i {
    margin-right: 3px;
  }
`;

function StudentHeaders(props) {
  const { students, className } = props;
  const mergedStudents = students.reduce((acc, student) => {
    if (student.concurrent === 0) {
      return [...acc, { ...student, numCols: 1 }];
    }
    const prev = last(acc);
    prev.numCols++;
    return acc;
  }, []);
  return (
    <NamesWrapper className={className}>
      {mergedStudents.map((student) => (
        <ColumnWrapper column key={student.offset} numCols={student.numCols}>
          <h4>
            {student.firstName || student.displayName}
            {student.event && <EventName>{student.event}</EventName>}
          </h4>
          <div>
            {student.meeting.details.assigned
              ? student.meeting.details.slots.map((slot) => (
                <SlotAlert key={slot.id} className="alert-success" title={student.meeting.details.set.title}>
                  <Icon className="ss-checkmark" inline />
                  {shortTimeString(slot, 'PPp')}
                </SlotAlert>
              ))
              : <SlotAlert className="alert-info"><FormattedMessage {...messages.notSelectedYet} /></SlotAlert>}
          </div>
        </ColumnWrapper>
      ))}
    </NamesWrapper>
  );
}

StudentHeaders.propTypes = {
  students: PropTypes.array,
  className: PropTypes.string,
};

export default StudentHeaders;
